module.exports = __webpack_public_path__ + "img/wlv_17.9896c5af.png";